var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CategoryForm',{attrs:{"backPath":"/categories","category":_vm.category}})}
var staticRenderFns = []

export { render, staticRenderFns }